import { slicedToArray as _slicedToArray, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { forwardRef, useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { findIconDefinition } from '@fortawesome/fontawesome-svg-core';
import '../../icons/library.js';
import { formatClassName as _formatClassName } from '../../utils/formatClassName.js';
var prefixes = {
  solid: 'fas',
  regular: 'far',
  light: 'fal',
  brands: 'fab',
  thin: 'fat'
};
var getIconFromLibrary = function getIconFromLibrary(icon, additionalProps, style) {
  var prefix = additionalProps && prefixes[additionalProps === null || additionalProps === void 0 ? void 0 : additionalProps.style] || prefixes[style];
  var definition = findIconDefinition({
    prefix: prefix,
    iconName: icon
  }); // check for default styling or if explicitly set

  if (!definition) {
    for (var _i = 0, _Object$values = Object.values(prefixes); _i < _Object$values.length; _i++) {
      var value = _Object$values[_i];
      var altDefinition = findIconDefinition({
        prefix: value,
        iconName: icon
      });
      if (altDefinition) return altDefinition;
    }
  }
  return definition;
};
var FAIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$additionalClas = props.additionalClasses,
    additionalClasses = _props$additionalClas === void 0 ? '' : _props$additionalClas,
    ariaLabel = props.ariaLabel,
    size = props.size,
    style = props.style,
    _props$color = props.color,
    color = _props$color === void 0 ? '' : _props$color,
    _props$maskIcon = props.maskIcon,
    maskIcon = _props$maskIcon === void 0 ? '' : _props$maskIcon,
    maskProps = props.maskProps,
    _props$layerIcon = props.layerIcon,
    layerIcon = _props$layerIcon === void 0 ? '' : _props$layerIcon,
    layerProps = props.layerProps,
    onClick = props.onClick,
    rotation = props.rotation,
    spin = props.spin,
    transform = props.transform;
  var _useState = useState(color),
    _useState2 = _slicedToArray(_useState, 2),
    colorClass = _useState2[0],
    setColorClass = _useState2[1];
  var _useState3 = useState(additionalClasses),
    _useState4 = _slicedToArray(_useState3, 2),
    extraClasses = _useState4[0],
    setExtraClasses = _useState4[1];
  useEffect(function () {
    setColorClass(color);
  }, [color]);
  useEffect(function () {
    setExtraClasses(additionalClasses);
  }, [additionalClasses]);
  var mask = maskIcon && getIconFromLibrary(maskIcon, maskProps, style);
  var layer = layerIcon && getIconFromLibrary(layerIcon, layerProps, style);
  var icon = props.style ? getIconFromLibrary(props.icon, {
    style: props.style
  }) : getIconFromLibrary(props.icon);
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    iconSize = _useState6[0],
    setIconSize = _useState6[1];
  useEffect(function () {
    if (size) {
      var mappedSize = {
        small: undefined,
        medium: '2x',
        large: '3x',
        extralarge: '4x'
      };
      setIconSize(mappedSize[size]);
    }
  }, [size]);
  if (!icon) return /*#__PURE__*/React.createElement(React.Fragment, null);
  var formattedAdditionalClasses = _formatClassName([colorClass, extraClasses, 'fa-icon', 'fa-fw']);
  var commonProps = {
    spin: spin,
    rotation: rotation,
    transform: transform,
    onClick: onClick,
    size: iconSize,
    className: "".concat(layerIcon && 'fa-inverse', " ").concat(formattedAdditionalClasses),
    'aria-label': ariaLabel,
    'data-action': "fa-".concat(icon.iconName)
  };
  if (layerIcon && layer) {
    return /*#__PURE__*/(
      // TODO: Remove this any after fixing the ref type
      React.createElement("span", {
        className: "fa-layers fa-fw fa-".concat(iconSize),
        ref: ref
      }, /*#__PURE__*/React.createElement(FontAwesomeIcon, _extends({
        icon: icon
      }, commonProps)), /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: layer,
        className: formattedAdditionalClasses,
        rotation: layerProps === null || layerProps === void 0 ? void 0 : layerProps.rotation,
        spin: layerProps === null || layerProps === void 0 ? void 0 : layerProps.spin,
        size: iconSize
      }))
    );
  }
  return /*#__PURE__*/React.createElement(FontAwesomeIcon, _extends({
    ref: ref,
    icon: icon,
    mask: maskIcon && mask ? mask : undefined
  }, commonProps));
});
FAIcon.displayName = 'FAIcon';
export { FAIcon };